import React from "react";
import "./css/footer.style.css";
import { NavLink } from "react-router";

const Footer = () => {
  return (
    <>
      <div className="freespace"></div>
      <div className="footer">
        <div className="container d-flex flex-column flex-md-row align-items-center justify-content-between">
          <div className="text-dark order-2 order-md-1">
            <span className="text-muted font-weight-bold">
              {new Date().getUTCFullYear()} &copy;
            </span>
            <NavLink to="" className="text-dark">
              Apni Kheti
            </NavLink>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
